import React from 'react';
import './profile-menu.scss';

import PropTypes from 'prop-types';
import classNames from 'classnames';
import Menu from '../../menu';
import PopupButton from '../../popup-button';
import menuItemShape from '../menu-item-shape';

const ProfileMenu = ({ items, isMobile, label }) => (
  <PopupButton
    className="popup-button--profile-menu"
    buttonBody={(
      <span
        className="profile-menu__toggle"
      >
        <span className={classNames('icon', 'profile-menu__icon', { 'profile-menu__icon--desktop': !isMobile })} />
        {!isMobile && <span className="profile-menu__icon-label">{label}</span>}
      </span>
    )}
    popupPosition={isMobile ? 'left' : 'right'}
    popupBody={<Menu items={items} />}
  />
);

ProfileMenu.propTypes = {
  items: PropTypes.arrayOf(menuItemShape),
  isMobile: PropTypes.bool,
  label: PropTypes.string.isRequired,
};

ProfileMenu.defaultProps = {
  items: [],
  isMobile: false,
};

export default ProfileMenu;
